
  (function () {
    var section = document.getElementById('template--20366902853848__c_collapsible_features_Gt3XWG');
    if (!section) return;

    section.querySelectorAll('.c-cf__item-header').forEach(function (header) {
      header.addEventListener('click', function () {
        var item = header.closest('.c-cf__item');
        var isOpen = item.classList.contains('c-cf__item--open');

        section.querySelectorAll('.c-cf__item').forEach(function (el) {
          el.classList.remove('c-cf__item--open');
        });

        if (!isOpen) {
          item.classList.add('c-cf__item--open');
        }
      });
    });
  })();


  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('#template--20366902853848__c_testimonials_v2_JaUcLr .c-tv2-native-facade').forEach(function (facade) {
      facade.addEventListener('click', function () {
        var video = this.previousElementSibling;
        this.style.display = 'none';
        if (video && video.tagName === 'VIDEO') video.play();
      });
    });

    document.querySelectorAll('#template--20366902853848__c_testimonials_v2_JaUcLr .c-tv2-video-facade').forEach(function (facade) {
      facade.addEventListener('click', function () {
        var type = this.dataset.videoType;
        var id   = this.dataset.videoId;
        var src  = '';

        if (type === 'youtube') {
          src = 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0';
        } else if (type === 'vimeo') {
          src = 'https://player.vimeo.com/video/' + id + '?autoplay=1';
        }

        if (!src) return;

        var iframe = document.createElement('iframe');
        iframe.src = src;
        iframe.className = 'c-tv2-embed';
        iframe.allow = 'autoplay; fullscreen; picture-in-picture';
        iframe.allowFullscreen = true;
        this.replaceWith(iframe);
      });
    });

    var section = document.getElementById('template--20366902853848__c_testimonials_v2_JaUcLr');
    var carousel = section && section.querySelector('.c-tv2-carousel.swiper');
    if (carousel && typeof Swiper !== 'undefined') {
      new Swiper(carousel, {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 12,
        watchOverflow: true,
        breakpoints: {
          769: {
            slidesPerView: 3,
            slidesPerGroup: 1,
            spaceBetween: 12
          }
        },
        navigation: {
          nextEl: '#template--20366902853848__c_testimonials_v2_JaUcLr .c-tv2-nav-next',
          prevEl: '#template--20366902853848__c_testimonials_v2_JaUcLr .c-tv2-nav-prev',
          disabledClass: 'swiper-button-disabled'
        }
      });
    }
  });


  (function () {
    var section = document.getElementById('template--20366902853848__c_pain_areas_DeJJxP');
    if (!section) return;

    var items = section.querySelectorAll('.c-pa__item');

    items.forEach(function (item) {
      item.addEventListener('click', function () {
        var target = item.getAttribute('data-pa-target');

        section.querySelectorAll('.c-pa__item').forEach(function (el) {
          el.classList.toggle('is-active', el === item);
        });

        section.querySelectorAll('.c-pa__media-img').forEach(function (el) {
          el.classList.toggle('is-active', el.getAttribute('data-pa-bg') === target);
        });

        section.querySelectorAll('.c-pa__overlay').forEach(function (el) {
          el.classList.toggle('is-active', el.getAttribute('data-pa-overlay') === target);
        });
      });
    });
  })();


  (function () {
    var section = document.getElementById('template--20366902853848__c_cards_grid_v2_bjxEDi');
    if (!section) return;
    var track = section.querySelector('.c-cg2__cards');
    var prev = section.querySelector('.c-cg2__arrow--prev');
    var next = section.querySelector('.c-cg2__arrow--next');
    if (!track || !prev || !next) return;

    function step() {
      var card = track.querySelector('.c-cg2__card');
      if (!card) return track.clientWidth;
      return card.getBoundingClientRect().width + 12;
    }

    function update() {
      var maxScroll = track.scrollWidth - track.clientWidth - 1;
      prev.classList.toggle('is-disabled', track.scrollLeft <= 0);
      next.classList.toggle('is-disabled', track.scrollLeft >= maxScroll);
    }

    prev.addEventListener('click', function () {
      track.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      track.scrollBy({ left: step(), behavior: 'smooth' });
    });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  })();


  (function () {
    var section = document.getElementById('template--20366902853848__c_product_list_MX9Pwy');
    if (!section) return;
    var row = section.querySelector('.c-pl__row');
    var cards = section.querySelectorAll('.c-pl__card');
    if (!row || !cards.length) return;

    function scrollAmount() {
      return cards[0].offsetWidth + 8;
    }

    var prev = section.querySelector('[data-dir="prev"]');
    var next = section.querySelector('[data-dir="next"]');

    if (prev) prev.addEventListener('click', function () {
      row.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
    });

    if (next) next.addEventListener('click', function () {
      row.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
    });
  })();


  document.addEventListener('DOMContentLoaded', function () {
    var section = document.getElementById('template--20366902853848__c_sliding_cards_yBkQMV');
    if (!section) return;
    var carousel = section.querySelector('.c-sc__track-wrap.swiper');
    if (!carousel || typeof Swiper === 'undefined') return;

    var swiper = new Swiper(carousel, {
      slidesPerView: 'auto',
      spaceBetween: 12,
      grabCursor: true,
      watchOverflow: true,
      navigation: {
        prevEl: '#template--20366902853848__c_sliding_cards_yBkQMV [data-dir="prev"]',
        nextEl: '#template--20366902853848__c_sliding_cards_yBkQMV [data-dir="next"]',
        disabledClass: 'c-sc__nav-btn--disabled'
      }
    });

    // Tap-to-toggle en dispositivos sin hover (touch). Swiper solo dispara 'click'
    // en un tap real, no al arrastrar, y expone la slide tocada en clickedSlide.
    swiper.on('click', function () {
      if (window.matchMedia('(hover: hover)').matches) return;
      var slide = swiper.clickedSlide;
      if (!slide || !slide.classList.contains('c-sc__card')) return;
      var wasOpen = slide.classList.contains('is-open');
      section.querySelectorAll('.c-sc__card.is-open').forEach(function (c) {
        c.classList.remove('is-open');
      });
      if (!wasOpen) slide.classList.add('is-open');
    });
  });


  (function () {
    var section = document.getElementById('template--20366902853848__c_faqs_v2_kDzaUM');
    if (!section) return;

    section.querySelectorAll('.c-fv2-question').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.c-fv2-item');
        var isOpen = item.classList.contains('is-open');

        section.querySelectorAll('.c-fv2-item').forEach(function (el) {
          el.classList.remove('is-open');
          el.querySelector('.c-fv2-question').setAttribute('aria-expanded', 'false');
          el.querySelector('.c-fv2-answer').setAttribute('aria-hidden', 'true');
        });

        if (!isOpen) {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
          item.querySelector('.c-fv2-answer').setAttribute('aria-hidden', 'false');
        }
      });
    });
  })();

